{
    "navbar": {
        "help_center": "Help center",
        "share_idea": "Share an idea",
        "logout": "Logout"
    },
    "languages": {
        "title": "Languages",
        "explanation": "You can change the language on your account by selecting one of the options below",
        "de": "German",
        "fr": "French",
        "en": "English",
        "it": "Italian",
        "es": "Spanish"
    },
    "form": {
        "submit": "Submit",
        "cancel": "Cancel",
        "errors": {
            "required": "This field is required"
        }
    },
    "menu": {
        "request_manager": {
            "title": "Request Manager",
            "pipeline": "Pipeline",
            "todo": "To Do",
            "inbox": "Inbox",
            "message_templates": "Message Templates"
        },
        "offer_manager": {
            "title": "Offer Manager",
            "itineraries": "Online Itineraries"
        },
        "cash_manager": {
            "title": "Cash Manager",
            "accounting": "Accounting"
        },
        "insights": {
            "title": "Insights",
            "statistics": "Statistics",
            "customer_satisfaction": "Customer Satisfaction",
            "better_trip_index": "Better Trip Index"
        },
        "tipi": {
            "title": "Trip Planner",
            "library": "Library"
        },
        "tools": {
            "title": "Resources Center",
            "partner_connect": "Partner Connect"
        },
        "agency_manager": {
            "title": "Agency Manager",
            "main_contacts": "Main Contacts",
            "active_accounts": "Active Accounts",
            "agency_capacity": "Agency Capacity",
            "legal_information": "Legal Information"
        }
    }
}
